var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12483 8.61103C1.02412 8.61055 0.925897 8.57973 0.842963 8.5226C0.76003 8.46547 0.696238 8.38467 0.659909 8.29074C0.623579 8.19681 0.616398 8.09412 0.639303 7.99605C0.662207 7.89798 0.714133 7.80909 0.788309 7.74097L4.50655 4.36275L0.788309 0.980031C0.737434 0.936491 0.695822 0.883177 0.665943 0.82325C0.636063 0.763324 0.618525 0.698006 0.614368 0.631173C0.610211 0.56434 0.61952 0.497352 0.641742 0.434185C0.663965 0.371017 0.698649 0.312957 0.743736 0.263448C0.788823 0.21394 0.843395 0.173991 0.904214 0.145973C0.965033 0.117955 1.03086 0.102438 1.09779 0.100343C1.16472 0.0982473 1.23139 0.109616 1.29384 0.133776C1.35629 0.157935 1.41326 0.194392 1.46135 0.240983L5.58612 3.99323C5.6376 4.04009 5.67873 4.09719 5.70687 4.16086C5.73501 4.22453 5.74955 4.29338 5.74955 4.363C5.74955 4.43262 5.73501 4.50147 5.70687 4.56514C5.67873 4.62881 5.6376 4.68591 5.58612 4.73277L1.46135 8.48102C1.36485 8.56802 1.24484 8.61103 1.12483 8.61103Z",
    fill: "#535969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowB);
export default __webpack_public_path__ + "static/media/arrowB.a3f1d9ddcd27e931e61518807a9b71f9.svg";
export { ForwardRef as ReactComponent };